// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
//import VeeValidate from 'vee-validate';
import router from './router';
import store from './store';
import myHttpApi from "./api/myhttpapi"
import VueMeta from 'vue-meta'

import AppReservation from './AppReservation';
import AppWebsite10 from './AppWebsiteV10';
import AppSalonReservation from './AppSalonReservation';
import AppError from './AppError';

Vue.config.productionTip = false;
Vue.$urlCDN = "https://posworldshopcdn.azurewebsites.net/";
//Vue.$urlCDN =  "http://192.168.0.127:16069/"; 

Vue.$currCatPicUrl = '';
Vue.$currCatName = '',
Vue.$storeSettings = {};
Vue.$storeSettings.StoreName = 'Posworld';
Vue.$selectedTime = {};
Vue.$isCustAppoints = false;
Vue.$baseUrl = '/';             //Lijst of blokken
Vue.$errorStartup = false;
Vue.$storeCustomer = undefined;
Vue.$errorLoading = false;
Vue.$isPaymentStatus = false;

Vue.$selectedStore = undefined;

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

if (!Vue.$isPosworld) Vue.$storeSettings.StoreName = 'Saloworld';

/* eslint-disable no-new */

var isInFrame = !(self==top)
if (isInFrame) document.body.style.backgroundColor = "#ffffff";

//Vue.$store.commit(SPINNER_SHOW);
Vue.$errorStartup = false;
myHttpApi.post( 'Settings/GetSettings')
   .then(response => {
    Vue.$storeSettings = response.data;

    var layout = 0;
    if (Vue.$storeSettings.ShopSiteData != null) {
      var jsdata = JSON.parse(Vue.$storeSettings.ShopSiteData)
      layout =  jsdata.KindLayout;
      Vue.$storeSettings.LayoutKind = layout
    }
    else
    {
      Vue.$storeSettings.LayoutKind = layout
    }

    

    execLayout01 (Vue.$storeSettings.LayoutKind);
    execLayout10_11 (Vue.$storeSettings.LayoutKind);  
    execLayout20 (Vue.$storeSettings.LayoutKind);  
   })
   .catch(error => {
      Vue.$errorLoading = true;
      execLayoutErr ()
  })

function execLayoutErr () {
    new Vue({
      el: '#app',
      router,
      store,
      template: '<AppError/>',
      components: { AppError },
    });
  }  
  
function execLayout01 (layout) {
    if (layout > 9) return;
    new Vue({
      el: '#app',
      router,
      store,
      template: '<AppReservation/>',
      components: { AppReservation },
    });
  }  

function execLayout10_11 (layout) {
  if ((layout != 10) && (layout != 11)) return;
  new Vue({
    el: '#app',
    router,
    store,
    template: '<AppWebsite10/>',
    components: { AppWebsite10 },
  });
}  

function execLayout20 (layout) {
  if (layout != 20) return;
  new Vue({
    el: '#app',
    router,
    store,
    template: '<AppSalonReservation/>',
    components: { AppSalonReservation },
  });
}  





// WEBPACK FOOTER //
// ./src/main.js